/* @flow */
export type State = {
  showingRecent: boolean,
};

export const initialState: State = {
  showingRecent: false,
};

export default function reducer(state: State = initialState, action: Object): State {
  switch (action.type) {
    case 'recentMessagesModal/SHOW_RECENT_MESSAGES':
      return { ...state, showingRecent: true };
    case 'recentMessagesModal/HIDE_RECENT_MESSAGES':
      return { ...state, showingRecent: false };
    default:
      return state;
  }
}

export function showRecent() {
  return {
    type: 'recentMessagesModal/SHOW_RECENT_MESSAGES',
  };
}

export function hideRecent() {
  return {
    type: 'recentMessagesModal/HIDE_RECENT_MESSAGES',
  };
}
